//@ts-nocheck
import { trackAddPaymentInfo } from '@/analytics/index'

function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop()?.split(';').shift() || null
  return null
}

export const AoeBraintree = {
  clientToken: '',
  hfSubmitBtn: '',
  refreshBtn: '',
  requestSource: '',
  bearerToken: '',
  enableThreeDSecure: false,
  cartTotal: 0,
  cartCurrency: 'EUR',
  cartFunnelType: 'individual',
  hostedFieldsText: {
    cardholderName: '',
    creditCardNumber: '',
    cvv: '',
    expirationDate: '',
  },
  sourceValues: {
    systemKeyword: '',
    aOECartIdToken: '',
  },
  walletExtendValues: {
    customerCardGuid: '',
    cusWalletGuid: '',
    expirationDate: '',
  },
  paymentValues: {
    paymentAmt: '',
    billingAddress1: '',
    billingAddress2: '',
    billingCity: '',
    billingPostal: '',
    billingState: '',
    billingCountry: '',
  },
  createPaymentUrl: '',
  walletExtendUrl: '',
  apiKey: '',
  getStatesServiceUrl: '',
  loggingServiceUrl: '',
  isUpdateMode: false,
  Initialize: function () {
    console.log('Loading Base Braintree')
    window.postMessage({ messageType: 'aoepaymentmethodloading' })
    braintree.client.create(
      {
        authorization: AoeBraintree.clientToken,
      },
      function (err, clientInstance) {
        console.debug('braintree.client.create')
        if (err) {
          console.error(err, AoeBraintree.clientToken)
          return
        }

        let threeDSecureInstance = null
        if (AoeBraintree.enableThreeDSecure && braintree?.threeDSecure?.create) {
          braintree.threeDSecure.create(
            {
              client: clientInstance,
              version: 2,
            },
            function (threeDSErr, instance) {
              if (threeDSErr) {
                console.error('threeDSecure.create error', threeDSErr)
                threeDSecureInstance = null
              } else {
                threeDSecureInstance = instance
              }
            },
          )
        }

        // Create input fields and add text styles
        const fieldsConfig = AoeBraintree.isUpdateMode ? {
          // Update mode: only expiration date field
          expirationDate: {
            selector: '#aoetbtCreditCardExpirationDate',
            placeholder: AoeBraintree.hostedFieldsText.expirationDate,
          },
        } : {
          // Create mode: all fields
          cardholderName: {
            selector: '#aoetbtNameOnCard',
            placeholder: AoeBraintree.hostedFieldsText.cardholderName,
          },
          number: {
            selector: '#aoetbtCreditCardNumber',
            placeholder: AoeBraintree.hostedFieldsText.creditCardNumber,
          },
          cvv: {
            selector: '#aoetbtCreditCardCVV',
            placeholder: AoeBraintree.hostedFieldsText.cvv,
          },
          expirationDate: {
            selector: '#aoetbtCreditCardExpirationDate',
            placeholder: AoeBraintree.hostedFieldsText.expirationDate,
          },
        }

        braintree.hostedFields.create(
          {
            client: clientInstance,
            styles: {
              input: {
                color: '#495057',
                'font-size': '1rem',
                transition: 'color 0.1s',
                'line-height': 'revert',
              },
              // Style the text of an invalid input
              'input.invalid': {
                color: '#E53A40',
              },
              'input:-ms-input-placeholder': {
                'line-height': '1.5em',
              },
              // placeholder styles need to be individually adjusted
              '::-webkit-input-placeholder': {
                color: 'rgba(black, 0.6)',
                'line-height': '1.5em',
              },
              ':-moz-placeholder': {
                color: 'rgba(black, 0.6)',
              },
              '::-moz-placeholder': {
                color: 'rgba(black, 0.6)',
              },
              ':-ms-input-placeholder': {
                color: 'rgba(black, 0.6)',
              },
            },
            // Add information for individual fields
            fields: fieldsConfig,
          },
          function (err, hostedFieldsInstance) {
            window.postMessage({ messageType: 'aoepaymentmethodloaded' })
            console.debug('braintree.hostedFields.create')
            if (err) {
              console.error(err)
              return
            }

            const submit = document.querySelector('#aoetbtSubmit')
            const nonce = document.querySelector('#aoetbtNonce')

            hostedFieldsInstance.on('validityChange', function (event) {
              console.debug('validityChange')
              // Check if all fields are valid, then show submit button
              const formValid = Object.keys(event.fields).every(function (key) {
                return event.fields[key].isValid
              })

              console.debug('validityChange', formValid)

              if (formValid) {
                submit.disabled = false
              } else {
                submit.disabled = true
              }
            })

            submit.addEventListener(
              'click',
              function (event) {
                event.preventDefault()
               hostedFieldsInstance.tokenize(function (err, payload) {
                  console.debug('tokenize')
                  if (err) {
                    console.error('tokenize error', err)
                    message = {
                      messageType: 'aoepaymentcreationerror',
                      messageData: err,
                    }
                    window.postMessage(message)
                    return
                  }
                  nonce.value = payload.nonce
                  AoeBraintree.LogResponse(payload)

                  if (AoeBraintree.isUpdateMode) {
                    AoeBraintree.WalletExtend(
                      payload,
                      AoeBraintree.walletExtendValues.customerCardGuid,
                      AoeBraintree.walletExtendValues.cusWalletGuid,
                      AoeBraintree.walletExtendValues.expirationDate
                    )
                  } else {
                    if (AoeBraintree.enableThreeDSecure && threeDSecureInstance && threeDSecureInstance.verifyCard) {
                      const aoetbtPaymentAmount = document.querySelector('#aoetbtPaymentAmount')
                      let charge = '0'
                      if (aoetbtPaymentAmount) {
                        const amountAttr = aoetbtPaymentAmount.getAttribute('data-amount')
                        charge = amountAttr != null && amountAttr !== '' ? amountAttr : '0'
                      }

                      const bin = payload?.details?.bin
                      if (!bin) {
                        AoeBraintree.CreatePayment(payload)
                        return
                      }

                      threeDSecureInstance.verifyCard(
                        {
                          amount: charge,
                          nonce: payload.nonce,
                          bin,
                          challengeRequested: true,
                          onLookupComplete: function (_data, next) {
                            next()
                          },
                        },
                        function (verifyErr, threeDSPayload) {
                          if (verifyErr) {
                            console.error('threeDSecure.verifyCard error', verifyErr)
                            const verifyErrCode =
                              typeof verifyErr === 'object' &&
                              verifyErr !== null &&
                              'code' in verifyErr
                                ? (verifyErr as { code?: unknown }).code
                                : undefined
                            if (verifyErrCode === 'THREEDS_USER_CANCELED') {
                              message = {
                                messageType: 'aoepaymentcreation3dsusercanceled',
                                messageData: verifyErr,
                              }
                              window.postMessage(message)
                              return
                            }
                            message = {
                              messageType: 'aoepaymentcreationerror',
                              messageData: verifyErr,
                            }
                            window.postMessage(message)
                            return
                          }

                          const threeDSInfo =
                            typeof threeDSPayload === 'object' &&
                            threeDSPayload !== null &&
                            'threeDSecureInfo' in threeDSPayload
                              ? (threeDSPayload as { threeDSecureInfo?: unknown }).threeDSecureInfo
                              : undefined
                          const threeDSStatus =
                            typeof threeDSInfo === 'object' &&
                            threeDSInfo !== null &&
                            'status' in threeDSInfo
                              ? (threeDSInfo as { status?: unknown }).status
                              : undefined
                          if (threeDSStatus === 'challenge_required') {
                            message = {
                              messageType: 'aoepaymentcreation3dsusercanceled',
                              messageData: threeDSInfo,
                            }
                            window.postMessage(message)
                            return
                          }
                          if (
                            threeDSStatus &&
                            threeDSStatus !== 'authenticated' &&
                            threeDSStatus !== 'authenticate_successful'
                          ) {
                            console.error('threeDSecure.verifyCard not authenticated', threeDSStatus, threeDSInfo)
                            message = {
                              messageType: 'aoepaymentcreationerror',
                              messageData: threeDSInfo,
                            }
                            window.postMessage(message)
                            return
                          }

                          nonce.value = threeDSPayload.nonce
                          const nextPayload = {
                            ...payload,
                            nonce: threeDSPayload.nonce,
                            threeDSecureInfo: threeDSPayload.threeDSecureInfo,
                          }
                          AoeBraintree.CreatePayment(nextPayload)
                        },
                      )
                    } else {
                      AoeBraintree.CreatePayment(payload)
                    }
                  }
                })
              },
              false,
            )
          },
        )
      },
    )
  },
  CreatePayment: function (payload) {
    console.debug('SavePayment', payload)
    const aoetbtPaymentAmount = document.querySelector('#aoetbtPaymentAmount')
    let charge = ''
    console.log('aoetbtPaymentAmount', aoetbtPaymentAmount)
    if (aoetbtPaymentAmount) {
      const amountAttr = aoetbtPaymentAmount.getAttribute('data-amount')
      charge = amountAttr != null && amountAttr !== '' ? amountAttr : '0'
    } else {
      charge = '0'
    }

    jsonDataToSave = {
      systemKeyword: AoeBraintree.sourceValues.systemKeyword,
      aOECartIdToken: AoeBraintree.sourceValues.aOECartIdToken,
      BraintreeHostedFieldTokenizeResponse: {
        ...payload,
        clientToken: AoeBraintree.clientToken,
      },
      charge: Number(charge),
      responseDefinition: {
        responseType: 1,
      },
    }
    if (
      AoeBraintree.createPaymentUrl &&
      AoeBraintree.createPaymentUrl.length > 0
    ) {
      const headers: Record<string, string | null> = {
        'x-api-key': AoeBraintree.apiKey,
        Authorization: AoeBraintree.bearerToken ? `Bearer ${AoeBraintree.bearerToken}` : null
      }
      const debugLoggingId = getCookie('X-Debug-Logging-Id')
      if (debugLoggingId) {
        headers['X-Debug-Logging-Id'] = debugLoggingId
      }

      jQuery.ajax({
        type: 'POST',
        url: AoeBraintree.createPaymentUrl,
        data: JSON.stringify(jsonDataToSave),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        headers: headers,
        success: function (result) {
          console.log('Processing complete', result)
          trackAddPaymentInfo(
            'credit card',
            AoeBraintree.cartTotal ?? 0,
            AoeBraintree.cartCurrency || 'EUR',
            AoeBraintree.cartFunnelType || 'individual'
          )
          message = {
            messageType: 'aoepaymentcreated',
            messageData: result,
            paymentData: jsonDataToSave,
          }
          window.postMessage(message)
        },
        error: function (result) {
          console.log('Processing error', result)
          message = {
            messageType: 'aoepaymentcreationerror',
            messageData: result.responseJSON,
          }
          window.postMessage(message)
        },
      })
    } else {
      console.error('createPaymentUrl is empty')
    }
  },
  CloseWindow: function () {
    $j.fancybox.close()
  },
  CloseParentWindow: function () {
    parent.window.$j.fancybox.close()
  },
  CloseWindowAndRefresh: function () {
    $j.fancybox.close()
    parent.window.performRefreshButton()
  },
  CloseParentWindowAndRefresh: function () {
    parent.window.$j.fancybox.close()
    const moid = document.getElementById('hfMasterOrderId').value
    let addedQueryString = parent.parent.window.location.href.split('#')[0]
    if (!addedQueryString.includes('&addedPayment=true'))
      if (!addedQueryString.includes('?'))
        addedQueryString = addedQueryString + '?addedPayment=true&moid=' + moid
      else addedQueryString = addedQueryString + '&addedPayment=true'
    parent.window.location.href = addedQueryString
  },
  CloseParentWindowAndPaymentReturn: function () {
    parent.window.$j.fancybox.close()
    parent.window.paymentReturn()
  },
  WalletExtend: function (payload, customerCardGuid, cusWalletGuid, expirationDate) {
    console.debug('WalletExtend', payload, customerCardGuid, cusWalletGuid, expirationDate)

    const jsonDataToSave = {
      systemKeyword: AoeBraintree.sourceValues.systemKeyword,
      customerCardGuid: customerCardGuid,
      cusWalletGuid: cusWalletGuid,
      expirationDate: expirationDate,
      BraintreeHostedFieldTokenizeResponse: {
        ...payload,
        clientToken: AoeBraintree.clientToken,
      },
    }

    if (
      AoeBraintree.walletExtendUrl &&
      AoeBraintree.walletExtendUrl.length > 0
    ) {
      const headers: Record<string, string | null> = {
        'x-api-key': AoeBraintree.apiKey,
        Authorization: AoeBraintree.bearerToken ? `Bearer ${AoeBraintree.bearerToken}` : null
      }
      const debugLoggingId = getCookie('X-Debug-Logging-Id')
      if (debugLoggingId) {
        headers['X-Debug-Logging-Id'] = debugLoggingId
      }

      jQuery.ajax({
        type: 'POST',
        url: AoeBraintree.walletExtendUrl,
        data: JSON.stringify(jsonDataToSave),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        headers: headers,
        success: function (result) {
          console.log('Wallet extend complete', result)
          message = {
            messageType: 'aoewalletextended',
            messageData: result,
          }
          window.postMessage(message)
        },
        error: function (result) {
          console.log('Wallet extend error', result)
          message = {
            messageType: 'aoewalletextenderr',
            messageData: result.responseJSON,
          }
          window.postMessage(message)
        },
      })
    } else {
      console.error('walletExtendUrl is empty')
    }
  },
  LogResponse: function (jsonDataToLog) {
    if (
      AoeBraintree.loggingServiceUrl &&
      AoeBraintree.loggingServiceUrl.length > 0
    )
      jQuery.ajax({
        type: 'POST',
        url: AoeBraintree.loggingServiceUrl,
        data: jsonDataToLog,
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
      })
  },
}
